import { createContext } from "react";

import type { Session } from "../model/session";

/** Undefined outside SessionProvider, so useSession can fail loudly on a missing mount. */
export const SessionContext = createContext<Session | undefined>(undefined);
